import {useEffect} from 'react';

export const useCleanArray=(data: any, obj: any, commonData:boolean)=>{
    const newData={...data,...obj};

    useEffect(()=>{
        const keys=Object.keys(newData);
       /* for ( const d in keys) {
            if (newData[keys[d]]===null)
                newData[keys[d]]= '';
            if (newData[keys[d]]===undefined)
                newData[keys[d]]= '';
        }*/
        //delete(newData['kommentar'])
        newData['common_data']=commonData;
    },[data]);
    return newData;
};